import Exception from './Exception';
export default class AlreadyDisposedException extends Exception {
    constructor(message, innerException) {
        if (innerException) {
            super(message, innerException);
        }
        else {
            if (message) {
                super(message);
            }
            else {
                super();
            }
        }
        this.name = 'AlreadyDisposedException';
    }
}
